import { EventTypes } from 'redux-segment';

import { aTypeUndoProcedure } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';

// TODO: convert to the newest form using actionEndpointBe
const undoProcedure = (salonId, procedureId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/undo/procedure/${procedureId}/`,
    authenticated: true,
    types: fromActionTypeToArray(aTypeUndoProcedure),
    params: { method: 'PUT', salonId, procedureId },
    config: { method: 'PUT', headers: { 'Content-Type': 'application/json' } },
    meta: { analytics: EventTypes.track },
  },
});

export default undoProcedure;
